import { AST } from '@handlebars/parser';
import { NodeType } from '../../../node/types';

export const isNumberLiteral = (expression: AST.Node): expression is AST.NumberLiteral =>
  expression.type === NodeType.NumberLiteral;
